module.exports = __webpack_public_path__ + "img/pump-south.a187f016.png";